import type { Occurrence } from '@shared/types';
import { Temporal } from 'temporal-polyfill';

export const renderDateTimes = (occurrence: Occurrence) => {
    const start = Temporal.ZonedDateTime.from(occurrence.times.start.zoned_datetime);
    const end = Temporal.ZonedDateTime.from(occurrence.times.end.zoned_datetime);

    if (start.toPlainDate().equals(end.toPlainDate())) {
        return (
            <span>
                {`${start.toLocaleString(undefined, { weekday: 'short', day: 'numeric', month: 'short' })}, `}
                {
                    <span className="">
                        {`${start.toLocaleString(undefined, { hour: 'numeric', minute: 'numeric' })} → ${end.toLocaleString(undefined, { hour: 'numeric', minute: 'numeric', timeZoneName: 'short' })}`}
                    </span>
                }
            </span>
        );
    } else {
        return `${start.toLocaleString(undefined, { day: 'numeric', month: 'numeric', year: '2-digit', hour: 'numeric', minute: 'numeric', timeZoneName: 'short' })} → ${end.toLocaleString(undefined, { day: 'numeric', month: 'numeric', year: '2-digit', hour: 'numeric', minute: 'numeric', timeZoneName: 'short' })}`;
    }
};
